import { ReactNode } from 'react';
import { Tooltip } from '@ds';

type InfoRowType = {
  name: string;
  value: ReactNode;
  icon: ReactNode;
  withTooltip?: boolean;
  labelIcon?: ReactNode;
  withTruncate?: boolean;
  textLink?: string;
};

export const InfoRow = ({
  name,
  value,
  icon,
  withTooltip = false,
  labelIcon,
  withTruncate = true,
  textLink,
}: InfoRowType) => (
  <div className="flex items-start gap-2.5">
    <span className="text-base-30 mt-2">{icon}</span>
    <div className="flex flex-col gap-1 min-w-0">
      <div className="text-m-r text-base-20 flex items-center gap-1">
        {name}
        {labelIcon && <span className="text-success-30">{labelIcon}</span>}
      </div>
      {withTooltip ? (
        <Tooltip content={value} showArrow>
          <div className={`text-l-r text-base-5 ${withTruncate ? 'truncate' : ''}`}>
            {textLink ? (
              <a href={textLink} className="hover:underline">
                {value}
              </a>
            ) : (
              value || '-'
            )}
          </div>
        </Tooltip>
      ) : (
        <div className={`text-l-r text-base-5 ${withTruncate ? 'truncate' : ''}`}>
          {textLink ? (
            <a href={textLink} className="hover:underline">
              {value}
            </a>
          ) : (
            value || '-'
          )}
        </div>
      )}
    </div>
  </div>
);
